export const HOST_API = process.env.REACT_APP_HOST_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = 'dashboard';
